import React, { useState } from 'react';
import Button from './Button';
import Icon from '../AppIcon';

const ShareButton = ({ title, description, url, price, productType = 'producto' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const shareData = {
    title: `${title} - Librería Lithay`,
    text: `${description} - Precio: $${price}`,
    url: url || window.location.href
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log('Error sharing:', err);
      }
    } else {
      setIsOpen(!isOpen);
    }
  };

  const shareOptions = [
    {
      name: 'WhatsApp',
      icon: 'MessageCircle',
      color: 'bg-green-500 hover:bg-green-600',
      action: () => {
        const text = encodeURIComponent(`🔥 ¡Descubre este increíble ${productType}! ${shareData.title}\n\n${shareData.text}\n\n¡No te lo pierdas! 👉 ${shareData.url}`);
        window.open(`https://wa.me/?text=${text}`, '_blank');
      }
    },
    {
      name: 'Facebook',
      icon: 'Facebook',
      color: 'bg-blue-600 hover:bg-blue-700',
      action: () => {
        const url = encodeURIComponent(shareData.url);
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
      }
    },
    {
      name: 'Twitter',
      icon: 'Twitter',
      color: 'bg-sky-500 hover:bg-sky-600',
      action: () => {
        const text = encodeURIComponent(`🔥 ${shareData.title} - ${shareData.text} ¡Imperdible! 📚`);
        const url = encodeURIComponent(shareData.url);
        window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank');
      }
    },
    {
      name: 'Copiar enlace',
      icon: 'Copy',
      color: 'bg-gray-500 hover:bg-gray-600',
      action: () => {
        navigator.clipboard.writeText(shareData.url).then(() => {
          alert('¡Enlace copiado al portapapeles!');
          setIsOpen(false);
        });
      }
    }
  ];

  return (
    <div className="relative">
      <Button
        variant="outline"
        size="sm"
        onClick={handleNativeShare}
        className="flex items-center gap-2 text-sm text-white border-[#0b3452] hover:bg-[#0b3452]/10"
        style={{ backgroundColor: '#0b3452' }}
      >
        <Icon name="Share2" size={16} />
        <span className="hidden sm:inline">Compartir {productType}</span>
      </Button>

      {/* Dropdown para navegadores sin soporte nativo */}
      {isOpen && !navigator.share && (
        <>
          {/* Overlay */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown Menu */}
          <div className="absolute right-0 top-full mt-2 w-48 bg-popover border border-border rounded-md shadow-modal py-2 z-50">
            <div className="px-3 py-2 text-sm font-medium text-popover-foreground border-b border-border">
              Compartir {productType}
            </div>
            {shareOptions.map((option) => (
              <button
                key={option.name}
                onClick={() => {
                  option.action();
                  setIsOpen(false);
                }}
                className="w-full flex items-center gap-3 px-3 py-2 text-sm text-popover-foreground hover:bg-muted transition-colors"
              >
                <div className={`p-1.5 rounded-full text-white ${option.color}`}>
                  <Icon name={option.icon} size={14} />
                </div>
                <span>{option.name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ShareButton;

